import { sendMessage } from '../utils'
import axios from 'axios'

const apiURL = process.env.PREACT_APP_API_URL
const baseURL = `${apiURL}/api/webchat`

const urlParams = new URLSearchParams(window.location.search)
const campaignId = urlParams.get('campaign_id')

const webIdKey = `sf_web_id_${campaignId}`
const initialWebId = urlParams.get('_sfid')

if (!campaignId) {
  throw new Error('Invalid URL: campaign_id is missing.')
}

if (initialWebId) {
  updateWebId(initialWebId)
}

axios.defaults.withCredentials = true

const defaultOptions = {
  baseURL,
  headers: {
    'X-SparkFire-Campaign-Id': campaignId
  }
}

const instance = axios.create(defaultOptions)

instance.interceptors.request.use(async (request) => {
  const webId = currentWebId()
  if(webId) {
    request.headers['X-SparkFire-Web-Id'] = webId
  }

  const sparkfireToken = localStorage.getItem('sparkfire_token')
  if(sparkfireToken) {
    request.headers['Authorization'] = `Bearer ${sparkfireToken}`
  }

  return request
})

instance.interceptors.response.use(
  (response) => {
    // Extract and send web ID to parent for storage
    const responseWebId = response.headers['x-sparkfire-web-id']
    if (responseWebId && responseWebId !== currentWebId()) {
      updateWebId(responseWebId)
    }

    return response.data
  },
  (error) => {
    console.log("API Error", error)
    throw error
  },
)

export const apiClient = instance

export function currentWebId() {
  return localStorage.getItem(webIdKey)
}

export function updateWebId(webId: string) {
  if (currentWebId() !== webId) {
    sendMessage('setWebId', { web_id: webId })
    localStorage.setItem(webIdKey, webId)
  }
}